import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdminService } from '../Services/admin.service';
import { LoginService } from '../Services/login.service';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const maintenanceGuard: CanActivateFn = () => {
    const adminService = inject(AdminService);
    const loginService = inject(LoginService);
    const router = inject(Router);

    const user = loginService.getUser();
    if (user?.role === 'ADMIN') {
        return of(true);
    }

    return adminService.getMaintenanceStatus().pipe(
        map((res) => {
            if (res.status === 1) {
                router.navigate(['/under-maintenance']);
                return false;
            }
            return true;
        }),
        catchError((err) => {
            console.error('Maintenance check failed:', err);
            // Fail closed — send to maintenance page rather than silently granting access
            router.navigate(['/under-maintenance']);
            return of(false);
        }),
    );
};
